export default function getResource(label, vars = []) {
    const resources = {
        deliveringTo: 'Delivering to ',
        yourLocation: 'your location',
        notAvailable: 'Same-Day Delivery not available for ',
        fastDeliveryNotAvailable: 'Fast Delivery not available for ',
        changeLocation: 'Change location'
    };
    return resources[label];
}
